<template>
  <hic-dialog :title="`费用标准项目${value.ifType ? '分类' : ''}编辑`" append-to-body @open="open" :close-on-click-modal="false" :visible="visible" width="50rem" @close="cancel" top="4vh">
    <el-form :inline="true" :model="value" :rules="comRules" ref="editor" label-width="6rem" label-position="right">
      <el-form-item label="名称" prop="name">
        <el-input type="text" placeholder="请输入" v-model.trim="value.name" auto-complete="new-account" class="edit-input" size="small" />
      </el-form-item>
      <el-form-item label="编码" prop="code">
        <el-input v-if="!value.id" type="text" placeholder="请输入" v-model.trim="value.code" class="edit-input" size="small"></el-input>
        <span v-else>{{ value.code }}</span>
      </el-form-item>
      <el-form-item v-if="!value.id" label=" " prop="ifType">
        <el-checkbox v-model="value.ifType" class="edit-input" size="small">作为项目分类编辑</el-checkbox>
      </el-form-item>
      <el-form-item v-else label="停用" prop="disabled">
        <el-checkbox v-model="value.disabled" class="edit-input" size="small">是</el-checkbox>
      </el-form-item>
      <el-form-item v-if="!value.ifType" label="包含内容" prop="inclusion">
        <el-input type="textarea" placeholder="请输入" v-model.trim="value.inclusion" :rows="5" style="width: 38rem" size="small"></el-input>
      </el-form-item>
      <el-form-item v-if="!value.ifType" label="除外内容" prop="exclusion">
        <el-input type="textarea" placeholder="请输入" v-model.trim="value.exclusion" style="width: 38rem" size="small"></el-input>
      </el-form-item>
      <el-form-item v-if="!value.ifType" label="单位" prop="unit">
        <el-input v-model="value.unit" class="edit-input" size="small" />
      </el-form-item>
      <el-form-item v-if="!value.ifType" label="价格" prop="price">
        <el-input type="text" placeholder="请输入单价" v-model="value.price" class="edit-input" size="small" />
      </el-form-item>
      <el-form-item v-if="!value.ifType" label="价格说明" prop="memo">
        <el-input type="textarea" placeholder="请输入" v-model.trim="value.priceMemo" :rows="1" class="edit-input" size="small"></el-input>
      </el-form-item>
      <el-form-item v-if="!value.ifType" label="标准类别" prop="standardClass">
        <hic-dict-selector dict-type="FeeStandardClass" v-model="value.standardClass" class="edit-input" />
      </el-form-item>
      <el-form-item v-if="!value.ifType" label="医保报销" prop="reimburseCategory">
        <hic-dict-selector dict-type="ReimburseCategory" v-model="value.reimburseCategory" class="edit-input" />
      </el-form-item>
      <el-form-item v-if="!value.ifType" label="工伤险报销" prop="injuryReimburseCategory">
        <hic-dict-selector dict-type="ReimburseCategory" v-model="value.injuryReimburseCategory" class="edit-input" />
      </el-form-item>
      <el-form-item v-if="!value.ifType" label="门诊结算" prop="opFeeType">
        <hic-dict-selector dict-type="FeeType" v-model="value.opFeeType" class="edit-input" />
      </el-form-item>
      <el-form-item v-if="!value.ifType" label="住院结算" prop="ipFeeType">
        <hic-dict-selector dict-type="FeeType" v-model="value.ipFeeType" class="edit-input" />
      </el-form-item>
      <el-form-item v-if="!value.ifType" label="统计类别" prop="statisticType">
        <hic-dict-selector dict-type="FeeStatisticType" v-model="value.statisticType" class="edit-input" />
      </el-form-item>
      <el-form-item label="备注" prop="memo">
        <el-input type="textarea" placeholder="请输入" v-model.trim="value.memo" :rows="5" style="width: 16rem" size="small"></el-input>
      </el-form-item>
      <el-form-item label="文件依据" prop="paper">
        <el-input type="textarea" placeholder="请输入" v-model.trim="value.paper" :rows="5" style="width: 16rem" size="small"></el-input>
      </el-form-item>
      <el-form-item label="国标编码" prop="gbCode">
        <el-input type="text" placeholder="请输入" v-model.trim="value.gbCode" class="edit-input" size="small"></el-input>
      </el-form-item>
      <el-form-item label="国标名称" prop="gbName">
        <el-input type="text" placeholder="请输入" v-model.trim="value.gbName" class="edit-input" size="small"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="cancel">关 闭</el-button>
      <el-button type="primary" @click="save" :disabled="saving">确 定</el-button>
    </div>
  </hic-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      value: Object,
    },
    data() {
      return {
        comRules: {
          code: [
            {
              required: true,
              message: "请输入编码",
              trigger: "blur",
            },
          ],
          name: [
            {
              required: true,
              message: "请选名称",
              trigger: "blur",
            },
          ],
          unit: [
            {
              required: true,
              message: "请输入单位",
              trigger: "blur",
            },
          ],

          price: [
            {
              required: true,
              message: "请输入价格",
              trigger: "blur",
            },
          ],

          standardClass: [
            {
              required: true,
              message: "请选择类别",
              trigger: "change",
            },
          ],
          opFeeType: [
            {
              required: true,
              message: "请选择费用类型",
              trigger: "change",
            },
          ],
          ipFeeType: [
            {
              required: true,
              message: "请选择费用类型",
              trigger: "change",
            },
          ],
        },
        saving: false,
      };
    },
    computed: {
      ...mapGetters(["dict"]),
    },
    methods: {
      open() {
        if (this.$refs.editor) this.$refs.editor.clearValidate();
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      save() {
        this.$refs.editor.validate().then((valid) => {
          if (valid) {
            this.saving = true;
            api.FeeStandard.save(this.value)
              .then((res) => {
                this.$message.success("保存成功!");
                this.$emit("ok");
                this.cancel();
              })
              .catch((err) => {
                this.$message.error(err);
              })
              .finally(() => {
                this.saving = false;
              });
          }
        });
      },
    },
  };
</script>
